import { OpenAIOutlined, EditFilled, RedoOutlined, CalendarOutlined, TranslationOutlined, UnorderedListOutlined, CloudSyncOutlined, FieldTimeOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';

export const useMultiMenuItems = () => {

  const items: MenuProps['items'] = [
    {
      label: 'Generera texter',
      key: 1,
      icon: <OpenAIOutlined />,
    },
    {
      label: 'Översätt texter',
      key: 5,
      icon: <TranslationOutlined />,
    },
    {
      label: 'Översätt specifikationer',
      key: 6,
      icon: <UnorderedListOutlined />,
    },
    {
      label: 'Redigera',
      key: 2,
      icon: <EditFilled />,
    },
    {
      label: 'Uppdatera från Kassanova',
      key: 3,
      icon: <RedoOutlined />
    },
    {
      label: 'Uppdatera kampanjdatum från Kassanova',
      key: 7,
      icon: <FieldTimeOutlined />
    },
    {
      label: 'Uppdatera extra fält',
      key: 4,
      icon: <CalendarOutlined />
    },
    {
      label: 'Synka till sökmotor',
      key: 8,
      icon: <CloudSyncOutlined />
    }
  ];

  return { menuItems: items};
};
